import Footer from 'components/home/Footer';
import {Col, Grid} from "../../mrf/view/Grid";
import AdminCard from "./AdminCard";
import IFAuth from "../../mrf/view/IFAuth";

export default function Dashboard() {
    return (
        <>
            <div id='hewwo' className='p-4 overflow-y-scroll h-footer-container'>
                <Grid gap={6}>
                    <IFAuth roleCodes={['admin']}>
                        <Col size={3} md={4}>
                            <AdminCard/>
                        </Col>
                    </IFAuth>
                </Grid>
            </div>
            <Footer/>
        </>
    );
}